import { IcUpload28, IcPlusCircle28 } from '$assets';
import React from 'react';
import { CloudAlbumsProps } from './CloudAlbums.interface';
import { CloudAlbumModel } from '$store/models';
import './CloudAlbums.sass';
import { Loader } from '$shared/components';
import { useTranslator } from '$hooks';
import { showModal } from '$navigation/helper';

enum InitialAlbums {
  UPLOADED = 'uploaded',
  MESSAGES = 'messages',
  POSTS = 'posts',
}

export const CloudAlbums = ({
  albums,
  isEditMode,
  onAlbumClick,
  isLoading,
  getAlbumTitle,
}: CloudAlbumsProps) => {
  const t = useTranslator();

  const formatAlbum = (album: CloudAlbumModel) => {
    if (album.title.toUpperCase() in InitialAlbums) {
      return {
        ...album,
        title: getAlbumTitle(album.title),
        isDeletable: false,
      };
    }
    return { ...album, isDeletable: true };
  };

  if (isLoading) {
    return <Loader isWrapped />;
  }

  return (
    <div className="Cloud__albums__grid">
      {albums.map((album) => {
        const { title, isDeletable, id } = formatAlbum(album);

        return (
          <div key={id} className="Cloud__albums__item" onClick={() => onAlbumClick(id)}>
            <div className="Cloud__albums__photo">
              {album.coverUrl ? (
                <img src={album.coverUrl} alt={title} />
              ) : (
                <div className="Cloud__albums__placeholder">
                  <IcUpload28 />
                </div>
              )}
            </div>
            <div className="Cloud__albums__info">
              <span className="Cloud__albums__title">{title}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};
